
import { useMediaQuery, Box } from "@mui/material";
import { Building, ClipboardList, Package, Plane, Weight } from "lucide-react";
import { ReadOnlyField } from "../shared/ReadOnlyField";

function AirTrackingHeading({ trackList }: { trackList: any }) {
    const isMobile = useMediaQuery("(max-width:600px)");
    const fields = [
        { label: "AWB Number", value: trackList?.awbNumber, Icon: ClipboardList},
        { label: "Destination", value: trackList?.destination, Icon: Building },
        { label: "Origin", value: trackList?.origin, Icon: Plane },
        { label: "Pkts", value: trackList?.pieces, Icon: Package },
        { label: "Weight", value: trackList?.weight, Icon: Weight },
    ];

    return (
        <div className="whiteBox whiteBoxCustom padding10">
            <Box component="form" noValidate autoComplete="off">
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-[1.2fr_1fr_1fr_0.9fr_0.9fr] gap-3">
                    {fields.map((field, index) => (
                        <ReadOnlyField key={index} {...field} isMobile={isMobile} />
                    ))}
                </div>
            </Box>
        </div>
    );
}

export default AirTrackingHeading;